import React, { Component } from 'react'
import { connect } from 'react-redux'
import {retrieveInsDon} from "../../actions";
import Bookingpage from './bookingpage';
import PageLayout from '../pagelayout';
import BookingMap from "./bookingmap";
import {Helmet} from "react-helmet";


class Booking extends Component {
    
    componentDidMount(){
        this.props.retrieveInsDon();
    }

    render() {
        const { data, fetching } = this.props.insDon;
        return (
            <PageLayout bgWhite Map={BookingMap}>
                <Helmet>
                <meta name="description" content="Download Ouja App and select a service suitable for you. Anything delivered anywhere in your city. Online booking options available. "/>
                <title>Book Ouja Services | Instant Delivery Services in Your City | Ouja App</title>
                <meta name="keywords" content="Services"/>
                </Helmet>
                {
                    fetching ?
                    <div className="flex-center" style={{height: `100px`}}>
                        <p>Loading....</p>
                    </div> : data && data.length > 0 ?
                    <Bookingpage 
                        history={this.props.history}
                        productItems={data[2]} 
                        insAmt={data[0].value} 
                        donAmt={data[1].value} 
                    /> : null
                }
            </PageLayout>
        )
    }
}

const mapStateToProps = ({insDon}) => ({
    insDon
})

const mapDispatchToProps = {
    retrieveInsDon
}

export default connect(mapStateToProps, mapDispatchToProps)(Booking)
